import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../components/layoutBlack";
import { RootState } from '../store/index.ts';
import { removeFromCart } from "../store/slices/cartSlice.ts";
import { useNavigate } from "react-router-dom";
import secureCheckoutImg from "../assets/images/icons/secure-checkout-png.png";


const ShoppingCart = () => {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.cart.items);
  const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0).toFixed(2);
  const navigate = useNavigate();


  const handleRemove = (id) => {
    dispatch(removeFromCart(id));
  };


  return (
    <Layout>
      <section className="full-page-section bg0 p-t-62 p-b-60">
        <div className="container">
          <form className="bg0 p-t-75 p-b-85">
            <div className="row">
              <div className="col-lg-10 col-xl-7 m-lr-auto m-b-50">
                <div className="m-l-25 m-r--38 m-lr-0-xl">
                  <div className="wrap-table-shopping-cart">
                    <table className="table-shopping-cart">
                      <thead>
                        <tr className="table_head">
                          <th className="column-1">Product</th>
                          <th className="column-2"></th>
                          <th className="column-3">Price</th>
                          <th className="column-4">Quantity</th>
                          <th className="column-5">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item) => (
                          <tr className="table_row" key={item.id}>
                            <td className="column-1">
                              <div className="how-itemcart1">
                                <img src={item.image} alt={item.name} />
                              </div>
                            </td>
                            <td className="column-2">{item.name}</td>
                            <td className="column-3">${item.price.toFixed(2)}</td>
                            <td className="column-4">{item.quantity}</td>
                            <td className="column-5">${(item.price * item.quantity).toFixed(2)}</td>
                            <td className="column-6">
                              <button className="btn btn-sm btn-danger" onClick={() => handleRemove(item.id)}>Remove</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="col-sm-10 col-lg-7 col-xl-5 m-lr-auto m-b-50">
                <div className="bor10 p-lr-40 p-t-30 p-b-40 m-l-63 m-r-40 m-lr-0-xl p-lr-15-sm">
                  <h4 className="mtext-109 cl2 p-b-30">Cart Totals</h4>
                  <div className="flex-w flex-t bor12 p-b-13">
                    <div className="size-208">
                      <span className="stext-110 cl2">Subtotal:</span>
                    </div>
                    <div className="size-209">
                      <span className="mtext-110 cl2">${total}</span>
                    </div>
                  </div>

                  <div className="flex-w flex-t p-t-27 p-b-33">
                    <div className="size-208">
                      <span className="mtext-101 cl2">Total:</span>
                    </div>
                    <div className="size-209 p-t-1">
                      <span className="mtext-110 cl2">${total}</span>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="flex-c-m stext-101 cl0 size-116 bg3 bor14 hov-btn3 p-lr-15 trans-04 pointer"
                    onClick={() => navigate("/shipping-info")}
                    >
                    Proceed to Checkout
                  </button>
                    <div className="mt-3 w-100 d-flex justify-content-center p-t-20" style={{ overflow: "hidden" }}>
                      <img
                        src={secureCheckoutImg}
                        alt="Guaranteed safe checkout"
                        style={{
                          display: "block",
                          width: "80%",
                          maxWidth: "80%",
                          height: "auto",
                        }}
                      />
                    </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </Layout>
  );
};

export default ShoppingCart;
